var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"role-box"},[_c('div',{staticClass:"role-title"},[_vm._v("请选择您的身份")]),_c('div',{staticClass:"role-all-item"},_vm._l((_vm.roleArr),function(item,index){return _c('div',{key:index,staticClass:"role-item",class:`role-item${index}`,style:({
        'background-image': `url(${item.b})`,
        'background-repeat': 'no-repeat',
        'background-size': 'contain',
      }),on:{"mouseenter":function($event){return _vm.mouseEnterLeave(
          _vm.roleGsap,
          `.role-item${index}`,
          1.1,
          0.5,
          'power2.out'
        )},"mouseleave":function($event){return _vm.mouseEnterLeave(_vm.roleGsap, `.role-item${index}`, 1, 0.5, 'power2.out')},"click":function($event){return _vm.roleChange(item.v)}}},[_c('div',{staticClass:"role-mc"},[_vm._v(_vm._s(item.t))]),_c('div',{staticClass:"role-jj"},[_vm._v(_vm._s(item.d))]),(item.v === `${_vm.yhlx}`)?_c('img',{staticClass:"role-qr",attrs:{"src":require("@/assets/images/js-xz.png")}}):_c('div',{staticClass:"role-qr"})])}),0),_c('div',{staticClass:"close-icon-role",on:{"click":_vm.close}},[_c('a-icon',{attrs:{"type":"close"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }